<template>
  <v-form class="form-content" v-model="formValid">
    <v-text-field
      type="password"
      label="Mật khẩu cũ"
      v-model="form.oldPassword"
      :rules="[validate.required]"
    ></v-text-field>
    <v-text-field
      label="Mật khẩu mới"
      v-model="form.newPassword"
      :rules="[validate.required]"
      :append-icon="isShowPassword ? `visibility_off` : `visibility`"
      :type="isShowPassword ? `text` : `password`"
      @click:append="isShowPassword = !isShowPassword"
    ></v-text-field>
    <v-btn block round color="success" @click="submit()" :loading="isLoading">Cập nhật</v-btn>
  </v-form>
</template>
<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';

export default {
  name: 'change-password',
  data () {
    return {
      formValid: false,
      validate: validate,
      isLoading: false,
      isShowPassword: false,
      form: {
        oldPassword: '',
        newPassword: ''
      }
    };
  },
  methods: {
    ...mapActions(['changePassword']),
    submit () {
      if (this.formValid) {
        this.isLoading = true;
        this.changePassword(this.form)
          .then(_ => {
            this.isLoading = false;
            window.getApp.showMessage('Đổi mật khẩu thành công');
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage('Đổi mật khẩu thất bại', 'error');
          });
      }
    }
  }
};
</script>
<style scoped>
.form-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/components/changepassword.vue